/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
/* eslint-disable @typescript-eslint/camelcase */
// eslint-disable-next-line lodash-fp/consistent-name, lodash-fp/use-fp
import { cloneDeep } from 'lodash'
import PropTypes from 'prop-types'
import React from 'react'
import DownCarot from '../../../assets/icons/carat.svg'
import List from '../../../components/List'
import SymmetryChart from './ChartComponents/Symmetry'

class BodySym extends React.Component {
  state = {
    HyperData: null
  }

  UNSAFE_componentWillMount() {
    this.setState({ HyperData: this.HyperData() })
  }

  UNSAFE_componentWillReceiveProps() {
    this.setState({ HyperData: this.HyperData() })
  }

  HyperData() {
    const { details } = this.props
    let data = cloneDeep(details)
    let d = []

    for (var key in data) {
      if (key === '_meta') delete data[key]
      else {
        // skip loop if the property is from prototype
        // eslint-disable-next-line no-prototype-builtins
        if (!data.hasOwnProperty(key)) continue

        var obj = data[key]

        d.push({
          display_name: obj.display_label,
          value: obj.value
        })
      }
    }

    return d.reverse()
  }

  render() {
    const { details, hotload } = this.props

    const items = {
      physicalActivity: {
        title: '<h2 class="mobile-padding">Body Symmetry</h2>',
        icon: { src: DownCarot },
        isShowAccordianOnMobile: true,
        accordianContent: `
      <div class="mobile-padding">
            <div>
              <p class="noMarginPadding">
              Body Symmetry assesses how a person’s body composition (muscle bulk,
            fat, and lean mass) and function (strength and dexterity) are evenly
            and symmetrically distributed across the left and right side of the
            body. Mild structural and functional asymmetry is normal, but severe
            asymmetry can have health implications and may indicate presence of
            disease.
              </p>
            </div>
              <br/>
          </div>`
      }
    }

    const listProps = {
      items,
      isMobile: this.props.isMobile,
      isNoTopBorder: true,
      isNotSpacer: true,
      isCollapsedDark: true,
      isReportStyle: true
    }

    let allInvalid = true
    for (let key in details) {
      if (details[key].__ok) {
        allInvalid = false
      }
    }

    return (
      <div className="bodysym-content module-content">
        <div className="intro-zone">
          {this.props.isMobile ? (
            <List {...listProps} />
          ) : (
            <p>
              Body Symmetry assesses how a person’s body composition (muscle
              bulk, fat, and lean mass) and function (strength and dexterity)
              are evenly and symmetrically distributed across the left and right
              side of the body. Mild structural and functional asymmetry is
              normal, but severe asymmetry can have health implications and may
              indicate presence of disease.
            </p>
          )}
        </div>
        <div className="bucket mobile-padding">
          <div>
            {hotload ? (
              <SymmetryChart
                details={details}
                label={'BodySym'}
                data={this.state.HyperData}
              />
            ) : null}
          </div>
          {allInvalid ? (
            <div className="no-report-data">{`No Data Available`}</div>
          ) : null}
        </div>
      </div>
    )
  }
}

BodySym.propTypes = {
  details: PropTypes.object.isRequired
}

export default BodySym
